<template lang="pug">
include ../../plugins/pug/template
v-card
  v-card-title
    span {{ $t('techSupport.title') }}
    v-spacer
    +btn-icon('', 'mdi-close')(@click="$emit('close')")

  v-card-subtitle {{ $t('techSupport.subtitle') }}
  v-card-text
    v-fade-transition
      div(v-if="isInquirySuccessSent")
        div.d-flex.justify-center.align-center.flex-column.mb-5
          v-icon(size="70").success--text.mb-1 mdi-check-circle-outline
          span.title {{ $t('techSupport.inquirySent') }}
        v-card(outlined)
          v-card-text
            +data-info('techSupport.number', 'inquiry.id', '', '')
            +data-info('techSupport.createAt', "$moment(inquiry.created_at).format('DD.MM.YYYY HH:mm')", '', '')
            +data-info('techSupport.statementCertificationLabel', 'inquiry.statement_number', '', '')(v-if="inquiry.statement_number")
            +data-info('techSupport.errorUrlLabel', 'inquiry.error_url', '', '')(v-if="inquiry.error_url").word-break-all
            +data-info('techSupport.additionalEmailLabel', 'inquiry.additional_email', '', '')(v-if="inquiry.additional_email")
            +data-info-status('techSupport.statusLabel', 'statuses.inquiry(inquiry.status)?.text', 'statuses.inquiry(inquiry.status)?.color')

    template(v-if="!isInquirySuccessSent")
      div(v-if="isInquiryError").mb-5
        div.d-flex.justify-center.align-center.flex-column.mb-2
          v-icon(size="70").error--text.mb-1 mdi-alert-circle-outline
          span.title {{ $t('techSupport.inquiryError') }}

        v-alert(type="error" text dense)
          div(v-if="isErrorStatementId") {{ $t('techSupport.inquiryErrorStatement', { certification: statementIdFromErrorResponse }) }}

          div(v-if="isErrorText") {{ $t('techSupport.inquiryErrorText') }}

      +field({
        model: 'body.statement_number',
        label: 'techSupport.statementCertificationLabel',
        validation: '["numeric"]'
      })

      +field({
        model: 'body.error_url',
        label: 'techSupport.errorUrlLabel',
        validation: '["url"]'
      })

      +field({
        model: 'body.additional_email',
        label: 'techSupport.additionalEmailLabel',
        validation: '["email"]'
      })

      +field-area({ model: 'body.text', label: 'techSupport.textLabel', placeholder: 'techSupport.textPlaceholder',
        validation: '["required"]' })

      FileUploader(ref="techSupportFile").techSupport-file

  v-card-actions
    v-spacer
    +btn-icon-text-simple('primary', "'+ btnCancelLabel +'", '')(
      :class="{'mr-4': !isInquirySuccessSent}"
      @click="$emit('close')"
    )

    +btn('primary', 'btn.save')(
      v-if="!isInquirySuccessSent"
      :loading="isLoading"
      @click="submit"
    )

</template>

<script>
import { inquiryTechSupport } from '@/configs/validationRules'
import { mapActions, mapState } from 'vuex'
import statuses from '@/configs/statuses'
import FileUploader from '@/components/FileUploader.vue'

export default {
  name: 'TechSupportForm',
  components: {FileUploader},
  data() {
    return {
      body: {
        from_url: '',
        statement_number: '',
        text: '',
        error_url: '',
        additional_email: '',
        upload_files: []
      },
      isLoading: false,
      statuses
    }
  },

  computed: {
    ...mapState({
      inquiry: state => state.techSupport.inquiry
    }),
    isInquirySuccessSent () {
      if (this.inquiry === null) return false
      return !!this.inquiry.id
    },
    isInquiryError () {
      if (this.inquiry === null) return false
      return this.inquiry?.error
    },
    btnCancelLabel () {
      return this.isInquirySuccessSent ? 'close' : 'btn.cancel'
    },
    errorsArrayKeys () {
      return Object.keys(this.inquiry.error_field)
    },
    isErrorStatementId () {
      return this.errorsArrayKeys.includes('statement_number')
    },
    statementIdFromErrorResponse () {
      if (this.isErrorStatementId) {
        return this.inquiry.error_field.statement_number[0].split('=')[1].split(' ')[0]
      }
      return false
    },
    isErrorText () {
      return this.errorsArrayKeys.includes('text')
    }
  },

  mounted () {
    this.body.from_url = window.location.href
  },

  validations: {
    body: inquiryTechSupport
  },

  methods: {
    ...mapActions(['postInquiryTechSupport']),
    async submit () {
      this.$v.body.$touch()
      if (!this.$v.body.$invalid) {
        this.isLoading = true
        this.body.upload_files = this.$refs.techSupportFile.getFiles().files
        await this.postInquiryTechSupport(this.body)
        this.isLoading = false
      }
    }
  }
}
</script>
